import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Grid, IconButton, Popover, PopoverProps, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

interface AdminReadmeProps {
  /** Specify the tooltip title that should be shown for the icon button.
   * @defaultValue `More info`
   */
  title?: string;
  /** The markdown content that should be rendered within the popover. */
  readme: string[];
  /** Specify the origin of the readme popover anchor.
   * @defaultValue bottom left of the readme help icon button.
   */
  anchorOrigin?: PopoverProps["anchorOrigin"];
  /** Specify the origin of the readme popover elements show animation.
   * @defaultValue top right corner of the popover content.
   */
  transformOrigin?: PopoverProps["transformOrigin"];
}

const AdminReadme: React.FC<AdminReadmeProps> = ({ anchorOrigin, transformOrigin, readme, title = "More Info" }) => {
  const [descriptionAnchor, setDescriptionAnchor] = useState<HTMLElement>();
  return (
    <>
      <Tooltip title={title}>
        <IconButton onClick={e => setDescriptionAnchor(e.currentTarget)} style={{ padding: "0px 8px" }}>
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(descriptionAnchor)}
        anchorEl={descriptionAnchor}
        onClose={() => setDescriptionAnchor(undefined)}
        anchorOrigin={anchorOrigin || { vertical: "bottom", horizontal: "left" }}
        transformOrigin={transformOrigin || { vertical: "top", horizontal: "right" }}
      >
        <Grid className="m-0" container spacing={2} style={{ padding: "8px", maxWidth: "40rem" }}>
          {readme.map((paragraph, index) => (
            <Grid item key={index}>
              <Typography variant="body1">{paragraph}</Typography>
            </Grid>
          ))}
        </Grid>
      </Popover>
    </>
  );
};

export default AdminReadme;
